var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84472 6.21323L15.666 4.52539L14.2171 10.4107L12.4096 8.67548L9.49389 11.7126C9.39491 11.8157 9.25816 11.874 9.11523 11.874C8.97231 11.874 8.83556 11.8157 8.73658 11.7126L6.5957 9.48256L3.44702 12.7624C3.24626 12.9716 2.91398 12.9783 2.70485 12.7776C2.49572 12.5768 2.48894 12.2445 2.6897 12.0354L6.21705 8.3611C6.31603 8.25799 6.45278 8.19971 6.5957 8.19971C6.73863 8.19971 6.87538 8.25799 6.97436 8.3611L9.11523 10.5912L11.6522 7.94846L9.84472 6.21323Z",
    fill: "#0E9A0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRise);
export default __webpack_public_path__ + "static/media/ArrowRise.8fed81aa8cb554ff10dc361d58e19852.svg";
export { ForwardRef as ReactComponent };